<template>
  <div id="app" ref="app" style="overflow: hidden;" >
    
    
    <router-view class="contentDiv000"></router-view>

    <BackTop />
     <CallMe class="bottomcss" />
      <!-- <AIassistant />
      <Book3D /> -->
      
   

  </div>
</template>

<script>
 
import CallMe from '@/components/callme/index'
// import AIassistant from '@/components/AI/index'
// import Book3D from '@/components/Book3d/index'
 
import Home from '@/views/Home'
export default {
  name: 'App',
  components: {
    Home,
    CallMe,
   
    
    // AIassistant,
    // Book3D
  },
  watch: {
    $route() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
  },
  methods:{
    handleBackTopClick(){
      this.currentScreen=1
    }
  }
}
</script>

 

<style lang="scss"> 

html {
   
 
  // font-size: calc(9px + 0.5vw);
  font-size: calc(17px + 0.15vw);
  /* 基础字号随视口变化 */
    @media screen and (max-width: 768px) {
      font-size: calc(8px + 1.2vw);
    }

    // /* 笔记本设备 */
    // @media screen and (min-width: 1024px) and (max-width: 1920px) {
    //   /* 笔记本样式 */
    //   font-size: calc(15px + 0.10vw);
    // }

    //    /* 台式机/大屏幕 */
    //    @media screen and (min-width: 1920px) {
    //   /* 台式机样式 */
    //   font-size: calc(10px + 0.05vw);
    // }

    /* 笔记本电脑 (通常16:9比例) */
@media screen and (min-width: 1366px) and 
       (max-width: 1919px) and 
       (min-aspect-ratio: 16/9) {
        font-size: calc(15px + 0.10vw);
}

/* 台式机 (可能更大或比例不同) */
@media screen and (min-width: 1920px),
       screen and (min-width: 1600px) and (min-aspect-ratio: 16/10) {
        font-size: calc(15px + 0.05vw);
}
}

 
// .fontCssJichu {
//   font-size: 16px;
// }
//  // 重置字体样式001
//  .fontCssJichu :not(.keep-style) {
//       // width: 90%;
//       // margin: 0 auto !important;
//       // margin-top: 1rem;
//       font-size:16px !important;
//       line-height: 36 !important;
//       // text-indent:2rem !important;
//       // text-align: left !important;

//       /* 设置最大最小值 */
//       @media (max-width: 320px) {
//         .fontCssJichu {
//           font-size: 16px;
//         }
//       }

//       @media (min-width: 1920px) {
//         .fontCssJichu {
//           font-size: 16px;
//         }
//       }
     
//     }


* {
  box-sizing: border-box;
}
.mainbody{
  // padding-bottom: 10rem;
}

.thirdLine {
  width: 100%;
    height: 80px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 50px 0;

    .line {
        display: inline-block;
        width: 30%;
        height: 0.5px;
        background: #015293;
    }
    .line1 {
        background: #015293;
    }

    .txt {
        color: #015293;
        vertical-align: middle;
        display: flex;
        flex-direction: column;
        font-size: 1.2rem;
        margin: 0 15px;
        span{
          font-size: 1.8rem;
        }
    }
    .txt1 {
        color: #015293;
        
    }
     
}

.thirdLine1 {
    height: 80px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 50px 0;

    .line {
        display: inline-block;
        width: 30%;
        height: 0.5px;
        background: #ffffff;
    }
    .line1 {
        background: #ffffff;
    }

    .txt {
        color: #ffffff;
        vertical-align: middle;
        display: flex;
        flex-direction: column;
        font-size: 1.2;
        margin: 0 15px;
    }
    .txt1 {
        color: #015293;
        vertical-align: middle;
        display: flex;
        flex-direction: column;
        font-size: 1.2;
        margin: 0 15px;
    }
     
}


 

.contentDiv000{
  min-height: 88vh;
  @media screen and (max-width: 768px) {
    // padding-bottom:3.5rem;
    // padding-bottom:5rem;
  }
}
.whiteHeight{
  width: 100%;
  height: 4rem;
}
.bottomcss{
  width:100vw; 
}
img{
  max-width: 100% !important;
  height: auto !important;
}
.topH1{
  @media screen and (max-width: 768px) {
    line-height:1.5rem !important;
    font-size: 1rem;
  }
}
.el-pagination{
  display: flex;
  justify-content: center;
}


/* main.css 或 App.vue */
.el-tooltip__popper.is-light {
  font-size: 1rem; /* 或者你想要的任何字体大小 */
  line-height: 2rem;
  max-width: 50vw;
}


@import url('./assets/css/icon.css');
@import url('./assets/css/gp.css');
@import url('./css/gp.css');
@import url('./css/ycss.css');


</style>
<style>
.blur-up {
  filter: blur(5px);
  transition: filter 0.3s;
}
.blur-up.lazyloaded {
  filter: blur(0);
}
</style>

<style lang="scss" src="./assets/css/scssMine.scss"></style>
